import { PARTNER_HIERARCHY_TYPE, PartnerHierarchyType } from '../types/partner';

// Helper for IPartnerV3 (snake_case — detail view)
export const getPartnerHierarchyType = (partner: {
  master_account_enabled?: boolean;
  parent_id?: string;
}): PartnerHierarchyType | undefined => {
  if (partner.parent_id) return PARTNER_HIERARCHY_TYPE.ORGANIZATION;
  if (partner.master_account_enabled) return PARTNER_HIERARCHY_TYPE.COMPANY;

  return undefined;
};

// Helper for IPartner / IModifiedPartner (camelCase — list view)
export const getPartnerHierarchyTypeFromList = (partner: {
  masterAccountEnabled?: boolean;
  parentId?: string;
  partnerType?: string;
}): PartnerHierarchyType | undefined => {
  if (
    partner.partnerType === PARTNER_HIERARCHY_TYPE.ORGANIZATION ||
    partner.parentId
  )
    return PARTNER_HIERARCHY_TYPE.ORGANIZATION;
  if (
    partner.partnerType === PARTNER_HIERARCHY_TYPE.COMPANY ||
    partner.masterAccountEnabled
  )
    return PARTNER_HIERARCHY_TYPE.COMPANY;

  return undefined;
};
